export const safeRequestIdleCallback =
	window.requestIdleCallback || ((cb: () => void) => setTimeout(cb, 0));
